<div class="grid-x grid-margin-x">
  <div class="cell small-12">Transformations:</div>
</div>
@for (tr of conf.transforms; track tr; let i = $index) {
  <div class="grid-x grid-margin-x border-one-pixel-solid-gray ">
    <div class="cell small-10">
      <label>Context Target :<input type="text" [(ngModel)]="tr.contextTarget" /></label>
    </div>
    <div class="cell small-2">
      <button class="button" (click)="removeRule(i)"><svg-icon icon="icon-trash"></svg-icon></button>
      @if (i > 0) {
        <button class="button" (click)="swapRules(i,i-1)"><svg-icon icon="icon-caret-up"></svg-icon></button>
      }
      @if (i < conf.transforms.length-1) {
        <button class="button" (click)="swapRules(i,i+1)"><svg-icon icon="icon-caret-down"></svg-icon></button>
      }
    </div>
    <div class="cell small-12">
      <label>Run if rule:<input type="text" [(ngModel)]="tr.condition" /></label>
    </div>
    <div class="cell small-12">
      <label>Value to assign Rule:<input type="text" [(ngModel)]="tr.expression" /></label>
    </div>
  </div>
}
<div class="grid-x grid-margin-x">
  <div class="cell small-12"><button (click)="addRule()" class="button"><svg-icon icon="icon-plus"></svg-icon></button>
</div>
</div>